import OptionInterface from "../../shared/interfaces/OptionInterface";

export const TOPIC_TYPES: OptionInterface<string>[] = [
  {
    label: "Usuarios",
    value: "mowi-user"
  },
  {
    label: "Conductores",
    value: "mowi-driver",
  },
  {
    label: "Pruebas",
    value: "mowi-test",
  },
  {
    label: "Todos",
    value: "mowi",
  },
  {
    label: "Usuarios/Conductores específicos",
    value: "mowi-specific",
  }
]